import React, {memo, useCallback} from 'react';
import PropTypes from 'prop-types';
import {Form, Input, Button} from 'antd';
import DeleteBin5LineIcon from 'remixicon-react/DeleteBin5LineIcon';
import styles from './index.less';
import {useCrudRunAudit} from '@/modules/auditorAudits/hooks/useAuditorAudits';

// eslint-disable-next-line no-unused-vars
const ContactInformationCell = ({value, form, initialValues, t, questionId, audit, runAudit, ...props}) => {
  // eslint-disable-next-line no-unused-vars
  const {updateContact} = useCrudRunAudit();

  const onSave = useCallback(async (contactInformationFields) => {
    const formValues = contactInformationFields ?? form?.getFieldValue('contactInformationFields');
    if (runAudit) {
      const contactFields = {
        _id: questionId,
        value: formValues
      };
      await updateContact({auditId: audit, contactFields});
    }
  }, [updateContact, audit, questionId, runAudit, form]);

  const handleContactBlur = useCallback(
    (e, fieldKey, fieldName) => {
      const contactInformationFields = form?.getFieldValue('contactInformationFields') ?? [];
      const updatedContactInformationFields = [...contactInformationFields];
      const updatedContact = {
        ...updatedContactInformationFields[fieldKey],
        [fieldName]: e?.target?.value,
      };

      updatedContactInformationFields[fieldKey] = updatedContact;
      form?.setFieldsValue({contactInformationFields: updatedContactInformationFields});

      if (updatedContact.email) {
        onSave(updatedContactInformationFields);
      }
    },
    [form, onSave],
  );

  return (
    <Form.List name={'contactInformationFields'}>
      {(fields, {add, remove}) => (
        <>
          {fields.map(({key, ...restField}) => (
            <div key={key} className="mb-3 flex justify-items-center">
              <Form.Item
                {...restField}
                name={[restField.name, 'name']}
                className="mb-0 w-full truncate"
                rules={[
                  {
                    required: true,
                  }
                ]}
              >
                <Input
                  placeholder={t('details.nameAuditorPlaceholder')}
                  value={value}
                  onBlur={(e) => handleContactBlur(e, restField?.name, 'name')}
                />
              </Form.Item>
              <Form.Item
                {...restField}
                name={[restField.name, 'email']}
                className="mb-0 w-full ml-1 truncate"
                rules={[
                  {
                    required: true,
                    message: t('form.invalidEmail'),
                    type: 'email',
                  }
                ]}
              >
                <Input
                  placeholder={t('details.emailsPlaceholder')}
                  value={value}
                  onBlur={(e) => handleContactBlur(e, restField?.name, 'email')}
                />
              </Form.Item>
              <Form.Item>
                <div className={styles.wrapperRemove}>
                  <DeleteBin5LineIcon className={`ml-2 ant-icon ${styles.removeIcon}`}
                    onClick={() => {
                      remove(restField?.name);
                      onSave();
                    }}/>
                </div>
              </Form.Item>
            </div>
          ))}
          <Button
            type={'link'}
            onClick={() => {
              add();
            }}
          >{t('form.add')}</Button>
        </>
      )}
    </Form.List>
  );
};

ContactInformationCell.propTypes = {
  required: PropTypes.bool,
  placeholder: PropTypes.string,
  subText: PropTypes.string,
  formName: PropTypes.string,
  value: PropTypes.any,
  form: PropTypes.any,
  initialValues: PropTypes.any,
  t: PropTypes.func,
  questionId: PropTypes.string,
  runAudit: PropTypes.bool,
  audit: PropTypes.string
};

ContactInformationCell.defaultProps = {
  required: true,
};

export default memo(ContactInformationCell);

/**
 * cellRender
 * */
/**
 * This is not a component,
 * it is a function to render the DynamicEmails component in a table cell
 * @param {String} text this is the value of the dataIndex of the table (we will ignored in this case)
 * @param {Object} entity this is the row instance
 * */
export const renderContactInformationCell = (text, entity) => {
  return (
    <ContactInformationCell entity={entity}/>
  );
};
